import React, { useState } from 'react';
import { Music, ArrowRight, CheckCircle, Info } from 'lucide-react';

export default function DotMoveCount() {
  const [inputName, setInputName] = useState('');
  const [steps, setSteps] = useState([]);
  const [syllables, setSyllables] = useState(0);

  const processName = () => {
    if (!inputName) return;
    
    // Simple mock logic for DOT-MOVE-COUNT demonstration
    const clean = inputName.trim();
    const mockSteps = [
      { label: 'Step 1: DOT (Pinpoint vowel sounds)', result: clean.replace(/[aeiou]/gi, '●') },
      { label: 'Step 2: MOVE (Isolate rhythmic units)', result: clean.split('').map(c => 'aeiou'.includes(c.toLowerCase()) ? `|${c}` : c).join('') },
      { label: 'Step 3: COUNT (Register final score)', result: `Total Syllables: ${clean.match(/[aeiou]/gi)?.length || 0}` }
    ];
    
    setSteps(mockSteps);
    setSyllables(clean.match(/[aeiou]/gi)?.length || 0);
  };

  const getStars = (s) => {
    if (s <= 2) return '⭐⭐⭐⭐⭐';
    if (s === 3) return '⭐⭐⭐';
    if (s === 4) return '⭐⭐';
    return '⭐';
  };

  return (
    <div className="min-h-screen bg-industrial-900 text-white p-12">
      <div className="max-w-2xl mx-auto shadow-2xl glass-card p-10">
        <header className="mb-10 text-center">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-brand/10 rounded-xl mb-4 text-brand">
            <Music className="w-6 h-6" />
          </div>
          <h1 className="text-3xl font-bold mb-2 tracking-tight uppercase">DOT-MOVE-COUNT</h1>
          <p className="text-industrial-400 font-light italic">"Listen to the rhythm, define the brand."</p>
        </header>

        <div className="space-y-8">
          <div>
            <label className="block text-xs font-mono text-industrial-500 uppercase tracking-widest mb-3">Audit Input</label>
            <div className="flex gap-4">
              <input 
                type="text" 
                value={inputName}
                onChange={(e) => setInputName(e.target.value)}
                placeholder="Enter Brand Name..."
                className="flex-1 bg-industrial-950 border border-industrial-800 rounded-lg px-4 py-3 text-xl font-bold tracking-tight focus:ring-1 focus:ring-brand outline-none"
              />
              <button 
                onClick={processName}
                className="bg-brand text-industrial-900 px-6 font-bold rounded-lg hover:bg-brand-dark transition-all"
              >
                Analyze
              </button>
            </div>
          </div>

          {steps.length > 0 && (
            <div className="space-y-6 animate-fade-in">
              {steps.map((step, i) => (
                <div key={i} className="flex gap-4 items-start">
                   <div className="w-8 h-8 rounded-full border border-brand/30 flex items-center justify-center text-[10px] font-mono shrink-0">
                     0{i+1}
                   </div>
                   <div className="flex-1 bg-industrial-800/50 p-4 rounded-lg border border-industrial-700">
                     <div className="text-[10px] text-industrial-500 uppercase font-mono mb-2">{step.label}</div>
                     <div className="text-lg font-mono text-brand tracking-widest">{step.result}</div>
                   </div>
                </div>
              ))}

              <div className="p-8 bg-brand/5 border border-brand/20 rounded-xl text-center">
                 <div className="text-xs uppercase tracking-widest text-industrial-400 mb-2">Platform Recommendation</div>
                 <div className="text-4xl font-bold text-white mb-2">{syllables} Syllables</div>
                 <div className="text-brand text-xl tracking-[0.5em]">{getStars(syllables)}</div>
                 <p className="text-xs text-industrial-500 mt-4 max-w-sm mx-auto">
                    Names with fewer syllables are prioritized for global accessibility and recall.
                 </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
